'use strict';
angular.module('appMarketplace')
    .controller('LegacyPageCtrl', ['$scope', 'UrlService', function ($scope, UrlService) {
        $scope.logoutUrl = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/controllers/legacy-page-ctrl.js
// module id = 236
// module chunks = 35